import React, { FC, useRef } from "react";
import type { HomePayProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const HomePay: FC<HomePayProps> = ({ title, cards }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="homePay">
      <div className="homePay--inner">
        <div className="wrapper">
          <div className="homePay--content">
            <SplitTextAnimation
              htmlElement={<h2 className="homePay--title">{title}</h2>}
              isInView={isInView}
            />
          </div>
        </div>
        <div className="wrapper wrapper_lg">
          <div className="homePay--content">
            <div className="homePay--cards" ref={ref}>
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="homePay--card"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition:
                        "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                    onMouseEnter={(event) => {
                      const target = event.currentTarget as HTMLElement;
                      target.classList.add("hover-animation-bounce");
                    }}
                    onAnimationEnd={(event) => {
                      const target = event.target as HTMLElement;
                      target.classList.remove("hover-animation-bounce");
                    }}
                  >
                    {card.image?.file?.url && (
                      <Image
                        className="homePay--card-icon"
                        noInline
                        src={card.image as any}
                        alt={card.image.title}
                        options={{
                          sizes: {
                            exec: [
                              {
                                width: 48,
                                height: 48,
                              },
                            ],
                          },
                        }}
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${40 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                    {card.title && (
                      <ContentManager
                        content={card.title}
                        className="homePay--card-title"
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${50 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                    {card.description && (
                      <ContentManager
                        content={card.description}
                        className="homePay--card-description"
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${60 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
